var _style, _rect, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSortDescDisabled(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "_x32_4_x__x_24",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 24 24",
    style: {
      enableBackground: "new 0 0 24 24"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0{fill:#FFFFFF;}\r\n\t.st1{fill:#C0D4E2;}\r\n")), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    className: "st0",
    width: 24,
    height: 24
  })), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M6.1,14.4l1.2-1.2C7.5,13,7.6,13,7.7,13C7.8,13,8,13,8,13.1l4,4l4-4C16,13,16.2,13,16.3,13 c0.1,0,0.2,0,0.3,0.1l1.2,1.2c0.1,0.1,0.1,0.2,0.1,0.3c0,0.1,0,0.2-0.1,0.3l-5.5,5.5c-0.1,0.1-0.2,0.1-0.3,0.1s-0.2,0-0.3-0.1 L6.1,15C6,15,6,14.8,6,14.7C6,14.6,6,14.5,6.1,14.4z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSortDescDisabled);
export default __webpack_public_path__ + "static/media/sort_desc_disabled.ab99c6d0c82942b486c521e02f195e59.svg";
export { ForwardRef as ReactComponent };